import { useState, useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { IconChevronDown } from '@tabler/icons';

import { useTranslation } from 'react-i18next';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Chip,
    ClickAwayListener,
    Divider,
    Grid,
    InputAdornment,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    OutlinedInput,
    Paper,
    Popper,
    Stack,
    Switch,
    Typography
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import UpgradePlanCard from './UpgradePlanCard';
import User1 from 'assets/images/users/user-round.svg';

// assets
import { IconLogout, IconSearch, IconSettings, IconUser } from '@tabler/icons';
import zeutecConfig from 'zeutecConfig';
import i18next from 'i18next';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
    const { t } = useTranslation();

    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();

    const [sdm, setSdm] = useState(true);
    const [value, setValue] = useState('');
    const [notification, setNotification] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const [role, setRole] = useState('admin');
    const [userName, setUserName] = useState('userName');

    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);
    const handleLogout = async () => {
        navigate('/');
        localStorage.clear();
        // console.log('Logout');
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListItemClick = (event, index, route = '') => {
        setSelectedIndex(index);
        handleClose(event);

        if (route && route !== '') {
            navigate(route);
        }
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        setRole(localStorage.getItem('role'));
        // console.log(localStorage.getItem('userName'))
        if (localStorage.getItem('userName') != null) {
            setUserName(localStorage.getItem('userName'));
        }
        prevOpen.current = open;
    }, [open]);

    function stringAvatar(name) {
        var name1 = name.userName.toUpperCase();
        return {
            children: `${name1.split(' ')[0][0]}`
        };
    }

    return (
        <>
            <Box
                ref={anchorRef}
                onClick={handleToggle}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    gap: 1.2
                }}
            >
                <Avatar
                    {...stringAvatar({ userName })}
                    sx={{
                        width: 40,
                        height: 40,
                        bgcolor: '#c80645',
                        color: '#f9f9f9'
                    }}
                />

                <Box>
                    <Typography
                        fontFamily={zeutecConfig.fontFamily}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#1c1c1c'
                        }}
                    >
                        {userName}
                    </Typography>

                    <Typography
                        fontFamily={zeutecConfig.fontFamily}
                        sx={{
                            fontSize: '12px',
                            color: '#8c8c8c',
                            textTransform: 'capitalize'
                        }}
                    >
                        {role}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        border: '1px solid #ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        ml: 1
                    }}
                >
                    <IconChevronDown size="1rem" stroke={1.5} />
                </Box>
            </Box>
            <Popper
                placement="bottom-end"
                sx={{
                    zIndex: 1300
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 10]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box>
                                        <Box sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                                            <Avatar
                                                {...stringAvatar({ userName })}
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    bgcolor: '#c80645',
                                                    color: '#f9f9f9'
                                                }}
                                            />

                                            <Stack sx={{ ml: 1.5 }}>
                                                <Stack direction="row" spacing={0.4} alignItems="center">
                                                    <Typography fontFamily={zeutecConfig.fontFamily} variant="h5">
                                                        {t('hello')}
                                                    </Typography>

                                                    <Typography fontFamily={zeutecConfig.fontFamily} variant="h5" sx={{ fontWeight: 600 }}>
                                                        {userName}
                                                    </Typography>
                                                </Stack>

                                                <Typography fontFamily={zeutecConfig.fontFamily} variant="body2" sx={{ color: '#8c8c8c' }}>
                                                    {role}
                                                </Typography>
                                            </Stack>
                                        </Box>

                                        <Divider />

                                        <List
                                            component="nav"
                                            sx={{
                                                width: '100%',
                                                maxWidth: 300,
                                                minWidth: 270,
                                                backgroundColor: theme.palette.background.paper
                                            }}
                                        >
                                            <ListItemButton
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 0}
                                                onClick={(event) => handleListItemClick(event, 0, './account-settings')}
                                            >
                                                <ListItemIcon>
                                                    <IconSettings stroke={1.5} size="1.3rem" />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography fontFamily={zeutecConfig.fontFamily} variant="body2">
                                                            {t('account_settings')}
                                                        </Typography>
                                                    }
                                                />
                                            </ListItemButton>

                                            <ListItemButton
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 1}
                                                onClick={handleLogout}
                                            >
                                                <ListItemIcon>
                                                    <IconLogout stroke={1.5} size="1.3rem" />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography fontFamily={zeutecConfig.fontFamily} variant="body2">
                                                            {t('logout')}
                                                        </Typography>
                                                    }
                                                />
                                            </ListItemButton>
                                        </List>
                                    </Box>
                                    {/* </PerfectScrollbar> */}
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>
        </>
    );
};

export default ProfileSection;
